<template>
  <div>
    <InstructionCondition :types="types" ref="condition" :titleBgColor="titleBgColor" :condition="condition" :targetHub="targetHub" :bgColor="'#ECECEC'">
      <template v-slot:commands>
        <hr class="lxn-margin-bottom-20 lxn-margin-top-20"/>
        <div class="lxn-w100 lxn-margin-top-20">
          <CommandCreator v-model="generatedCommandInput" :title="$store.getters.language.texts.AddSchedule_text18" titleBgColor="#00AEEF" :bgColor="getBgColorData()" :multiHub="false" :outputsOnly="true" :noHubSelect="true" :hubIndex="targetHub" :showAutomations="false" :showInputs="false" :loadFrom="generatedCommandInputData" />
        </div>
        <div class="lxn-w100 lxn-margin-top-20">
          <CommandCreator v-model="generatedCommandOutput" :title="$store.getters.language.texts.AddSchedule_text17" titleBgColor="#00AEEF" :bgColor="getBgColorData()" :multiHub="false" :outputsOnly="true" :noHubSelect="true" :hubIndex="targetHub" :showAutomations="false" :showInputs="false" :loadFrom="generatedCommandOutputData" />
        </div>
      </template>
    </InstructionCondition>
  </div>
</template>

<script>
import * as CONFIGS from '@/statics/configs.js'
import Vue from "vue";
import * as moment from "jalali-moment";
import Messaging from "@/statics/messaging";
import Logger from "@/statics/logger";
import InstructionCondition from "@/components/Instruction/InstructionCondition";
import TitleBox from "@/components/TitleBox";
import CommandCreator from "@/components/CommandCreator";

const messaging = new Messaging(new Logger(false));

export default {
  name: 'Instruction',
  props: {
    instructionId: Number,
    index: Number,
    titleBgColor: String,
    className: String,
    condition: Object,
    bgColor: String,
    deleteCondition: Function,
    targetHub: Number,
    types: [],
  },
  components: {
    InstructionCondition,
    TitleBox,
    CommandCreator
  },
  data: function () {
    return {
      id: this.instructionId || this.newInstructionId(),
      conditions: this.condition.conditions,
      type: this.condition.type,
      bgColorData: this.bgColor,
      CONFIGS,
      date: new Date().toLocaleDateString('fa-IR-u-nu-latn'),
      hour: new Date().getHours(),
      minute: new Date().getMinutes(),
      endHour: new Date().getHours(),
      endMinute: new Date().getMinutes(),
      onDuration: 0,
      offDuration: 0,
      repeatDays: [false, false, false, false, false, false, false],
      duration: 0,
      generatedCommandInput: [],
      generatedCommandOutput: [],
      generatedCommandInputData: [],
      generatedCommandOutputData: [],
      targetOutput: 0,
      switchState: 'on',
    }
  },
  mounted: function () {
  },
  watch: {
    'type': function () {
      this.conditions = [];
      if (this.type === CONFIGS.INSTRUCTION_CONDITION_TYPE.AND || this.type === CONFIGS.INSTRUCTION_CONDITION_TYPE.OR){
        this.conditions = [{type: 0, conditions: []}, {type: 0, conditions: []}];
      }
    }
  },
  computed: {

    dropDownTargetOutputs: function () {
      var dropDownTargetOutputs = {
        name: "Scenario-TargetOutputs",
        title: this.$store.getters.language.texts.CommandCreator_text2,
        selectedIndex: this.targetOutput,
        data: []
      };
      for(var i = 0; i < this.$store.state.nodes.length; i++){
        if(this.$store.state.hubs[this.targetHub].uuid === this.$store.state.nodes[i].hubUUID){
          for(var j = 0; j < this.$store.state.nodes[i].outputs.length; j++){
            dropDownTargetOutputs.data.push({
              name: this.$store.state.nodes[i].name + ' > ' + this.$store.state.nodes[i].outputs[j].name,
              icon: this.$store.state.nodes[i].outputs[j].icon,
              data: {
                node: this.$store.state.nodes[i],
                output: this.$store.state.nodes[i].outputs[j],
                outputIndex: j
              }
            })
          }
        }
      }
      this.$store.state.hubs.map(x => [...(x.outputs?.internal || []).map(i => {
        return {
          node: {uuid: x.uuid, name: x.name},
          output: {parameterId: i.parameterId, name: i.name, type: "internal"},
        };
      }), ...(x.outputs?.expansion1 || []).map(i => {
        return {
          node: {uuid: x.uuid, name: x.name},
          output: {parameterId: i.parameterId, name: i.name, type: "internal"},
        };
      }), ...(x.outputs?.expansion2 || []).map(i => {
        return {
          node: {uuid: x.uuid, name: x.name},
          output: {parameterId: i.parameterId, name: i.name, type: "internal"},
        };
      })]).flatMap(x => x).forEach((x, j) => {
        dropDownTargetOutputs.data.push({
          name: x.node.name + ' > ' + x.output.name,
          icon: "hub",
          data: {
            node: x.node,
            output: x.output,
            outputIndex: j,
          }
        })
      });
      return dropDownTargetOutputs;
    },
  },
  methods: {
    newInstructionId: function () {
      let maxId = this.$parent.$options.name === 'AddInstruction' ? 19999 : this.$parent.$options.name === 'AddSchedule' ? 9999 : 0;
      if (this.$parent.$options.name === 'AddInstruction'){
        for (const iId of this.$store.state.instructions.map(x => x.instructionId)) {
          if (iId > maxId) maxId = iId;
        }
      }
      if (this.$parent.$options.name === 'AddSchedule'){
        for (const iId of this.$store.state.schedules.map(x => x.instructionId)) {
          if (iId > maxId) maxId = iId;
        }
      }
      maxId++
      return maxId + (this.index || 0);
    },
    getHourMinuteFromTimeStamp(timeStamp) {
      const totalMinutes = Math.floor(timeStamp / 60000);
      const hour = Math.floor(totalMinutes / 60);
      const minute = totalMinutes % 60;
      const HH = String(hour).padStart(2, '0');
      const mm = String(minute).padStart(2, '0');
      return {hour: HH, minute: mm};
    },
    getDateTimeFromStamp(dateStamp, timeStamp) {
      const epochTime = dateStamp * 86400000 + timeStamp;
      const m = moment(epochTime).locale('fa');
      return {
        date: m.format('YYYY/MM/DD'),
        hour: m.format('HH'),
        minute: m.format('mm'),
      };
    },
    numberToBooleanList(num) {
      const binaryStr = num.toString(2);
      const res = [...binaryStr].map(bit => bit === '1');
      return [res[1], res[2], res[3], res[4], res[5], res[6], res[0]];
    },
    getDateTimeStamp(date, hour, minute)
    {
      const epochTime = moment.from(date + ' ' + hour + ':' + minute, 'fa', 'YYYY/MM/DD HH:mm').locale('en').valueOf();
      var dateStamp = Math.floor(epochTime / 86400000);
      var timeStamp = epochTime % 86400000;
      return {date: dateStamp, time: timeStamp};
    },
    getTimeStamp(hour, minute)
    {
      return (hour * 60 + minute) * 60000;
    },
    getRepeatMask()
    {
      return Number(`0b0${this.repeatDays[6] ? 1 : 0}${this.repeatDays[0] ? 1 : 0}${this.repeatDays[1] ? 1 : 0}${this.repeatDays[2] ? 1 : 0}${this.repeatDays[3] ? 1 : 0}${this.repeatDays[4] ? 1 : 0}${this.repeatDays[5] ? 1 : 0}`);
    },
    checkData: function (condition) {
      if (condition.type === CONFIGS.INSTRUCTION_CONDITION_TYPE.NONE){
        alert(this.$store.getters.language.texts.AddScenario_alert2);
        return false;
      } else if (condition.type === CONFIGS.INSTRUCTION_CONDITION_TYPE.WEEKLY){
        if (condition.weekly.repeatMask === 0){
          alert(this.$store.getters.language.texts.AddScenario_alert3);
          return ;
        }
      } else if (condition.type === CONFIGS.INSTRUCTION_CONDITION_TYPE.PERIODIC){
        if (condition.periodic.on === 0 || condition.periodic.off === 0){
          alert(this.$store.getters.language.texts.AddScenario_alert4);
          return false;
        }
      } else if (condition.type === CONFIGS.INSTRUCTION_CONDITION_TYPE.AND || condition.type === CONFIGS.INSTRUCTION_CONDITION_TYPE.OR){
        return condition.conditions.every(x => this.checkData(x));
      }
      if (this.generatedCommandInput.length <= 0){
        alert(this.$store.getters.language.texts.AddScenario_alert5);
        return false;
      }
      return true;
    },
    setData: function (instruction) {
      this.$refs.condition.setData(instruction.condition);
      this.generatedCommandInputData = instruction.onSetNodes.actions.flatMap(x => {
        return x.actions.map(a => {
          const node = this.$store.getters.getNodeByUUID(x.nodeUuid);
          const hub = this.$store.getters.getHubByUUID(node.hubUUID);
          return {
            hub: hub,
            node: node,
            output: {parameterId: a.parameterId},
            state: a.valueOfChange === 1 ? 'on' : 'off',
            delay: a.timeDelay
          }
        })
      });
      this.generatedCommandOutputData = instruction.onClearNodes.actions.flatMap(x => {
        return x.actions.map(a => {
          const node = this.$store.getters.getNodeByUUID(x.nodeUuid);
          const hub = this.$store.getters.getHubByUUID(node.hubUUID);
          return {
            hub: hub,
            node: node,
            output: {parameterId: a.parameterId},
            state: a.valueOfChange === 1 ? 'on' : 'off',
            delay: a.timeDelay
          }
        })
      });
    },
    getData: function () {
      const condition = this.$refs.condition.getData();
      return this.checkData(condition) ? {
        instructionId: this.id,
        condition: condition,
        onSetNodes: {
          actions: this.generatedCommandInput.length > 0 ? this.generatedCommandInput[0].actions.map(x => {
            return {
              deviceUUID: x.nodeUUID,
              actions: [
                {
                  parameterId: x.parameterId,
                  valueOfChange: x.valueOfChange,
                  typeOfAction: x.typeOfAction,
                  timeDelay: x.timeDelay,
                }
              ]
            };
          }) : [],
          packetType: messaging.UPLINK_PACKET_SEND_COMMAND
        },
        onClearNodes: {
          actions: this.generatedCommandOutput.length > 0 ? this.generatedCommandOutput[0].actions.map(x => {
            return {
              deviceUUID: x.nodeUUID,
              actions: [
                {
                  parameterId: x.parameterId,
                  valueOfChange: x.valueOfChange,
                  typeOfAction: x.typeOfAction,
                  timeDelay: x.timeDelay,
                }
              ]
            };
          }) : [],
          packetType: messaging.UPLINK_PACKET_SEND_COMMAND
        }
      } : null;
    },
    toggleSwitchState: function () {
      if(this.switchState === 'on'){
        this.switchState = 'off';
      }else{
        this.switchState = 'on';
      }
    },
    getClass: function () {
      return this.className;
    },
    repeatDaysSelected: function (index) {
      if(this.repeatDays[index] === true){
        return 'active';
      }else{
        return '';
      }
    },
    daySelected: function (index) {
      const newVal = !this.repeatDays[index];
      Vue.set(this.repeatDays, index, newVal);
    },
    getBgColor: function () {
      return this.bgColorData;
    },
    getBgColorData: function () {
      return this.bgColorData === '#D8D8D8' ? '#ECECEC' : '#D8D8D8';
    },
    deleteThisCondition: function (idx) {
      this.conditions.splice(idx, 1);
    },
    addCondition: function () {
      if (this.conditions){
        this.conditions.push({type: 0, conditions: []})
      } else {
        this.conditions = [{type: 0, conditions: []}];
      }
      this.$forceUpdate();
    },
    showAdd: function () {
      return this.type === CONFIGS.INSTRUCTION_CONDITION_TYPE.AND || this.type === CONFIGS.INSTRUCTION_CONDITION_TYPE.OR
    },
  }
}
</script>

<style>
  .AddScenario-wrapper-name-text {
    height: 50px;
    padding-top: 20px;
    line-height: 30px;
    color: #52626C;
  }
  .AddScenario-wrapper-padding-0 {
    padding: 0;
    height: unset;
  }
  .AddSchedule-commandDelay-button {
    -webkit-appearance: none;
    transition: opacity 0.5s ease;
    background: #1EA5DE;
    border: 0;
    border-radius: 7px;
    overflow: hidden;
    color: #fff;
    cursor: pointer;
    float: left;
    font-size: 20px;
    height: 40px;
    margin: 0;
    width: 40px;
  }
  .AddSchedule-commandDelay-button:hover {
    opacity: 0.5;
  }
  .AddSchedule-commandDelay-button:hover {
    opacity: 0.5;
  }
  .AddSchedule-commandDelay-button:focus {
    outline: 0;
    outline-offset: 0;
  }
  .AddSchedule-days {
    width: calc(100% / 7 - 4px);
    height: 40px;
    margin-right: 2px;
    margin-left: 2px;
    line-height: 40px;
    background-color: #53636C;
    color: #FFFFFF;
  }
  .AddSchedule-days.AddSchedule-days-mini {
    height: 18px;
    margin-right: 1px;
    margin-left: 1px;
    font-size: 10px;
    line-height: 18px;
  }
  .AddSchedule-days.active {
    background-color: #1EA5DE;
  }
</style>
